var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cssAlign},[_c('div',{staticClass:"loader",class:_vm.cssClass},_vm._l((_vm.squares),function(index){return _c('div',{key:index,staticClass:"square"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }